import { GENDER } from "../constants/common";

export interface Farmer {
  id: string;
  full_name: string;
  phone_number: string;
  short_address: string;
}

export enum LAND_UNITS {
  "ACRES" = "Acres",
  "HECTARE" = "Hectare",
  "BIGHA" = "Bigha",
}

interface Profile {
  age: string;
  gender: GENDER;
  display_age: string;
  smartphone_user: boolean;
  total_leased_land: string | null;
  total_leased_land_unit: LAND_UNITS | null;
  dairy_farmer: boolean;
}

export interface Address {
  block?: string;
  block_id?: string;
  district?: string;
  district_id?: string;
  pin_code: string;
  state?: string;
  state_id?: string;
  village?: string;
  village_id?: string;
}

export interface FarmerDetails extends Farmer {
  gender: GENDER;
  age: number;
  full_address: string;
  address: Address;
  total_land_area: string;
  livestock_display: string;
  last_one_yr_order_total: string;
  is_smartphone_user: boolean;
  profile: Profile;
  auth_id: string;
}

export interface Farm {
  id: string;
  name: string;
  buyer_full_name: string;
  lat_lng: string;
  photo: string;
  farm_nerax_report: string;
  area_by_shape_file: string | null;
  area_by_shape_file_land_unit: string | null;
  crop_image: string | null;
}

export interface Livestock extends IdNameImage {
  quantity: number;
}

export interface IdNameImage {
  id: string;
  name: string;
  image_url: string;
}

export interface FarmerLivestock extends IdNameImage {
  is_active: boolean;
  livestock_id: string;
  quantity: number;
}

export interface FarmerProducts {
  crop: IdNameImage;
  products: {
    id: string;
    image_url: string;
    product_id: string;
    product_name: string;
  }[];
}

export interface FarmerInfo {
  auth_id: string;
  bio: string;
  full_name: string;
  id: number;
  is_verified: boolean;
  odoo_id: number;
  phone_number: string;
  photo_S3_path: string | null;
  tagline: string | null;
}

export interface DcAndFarmer {
  id: number;
  dehaat_center: number;
  farmer: FarmerInfo;
  credit_value: string;
  total_sales: string;
  is_farmer_promotion_allowed: boolean;
}
